import React from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";
import Select from "react-select";

const Row = props => {
  return (
    props.children && (
      <div className={"row"}>
        <div className="col-sm-6">{props.children[0]}</div>
        <div className="col-sm-6">{props.children[1]}</div>
      </div>
    )
  );
};

const customStyles = {
  menu: (provided, state) => ({
    ...provided,
    zIndex: 1000
  })
};

class ReportsSearchReact extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      startDate: undefined,
      endDate: undefined,
      customer: "",
      supplier: "",
      screwType: undefined,
      screwDiameter: [],
      screwLength: [],
      productDescription: "",
      template: undefined,
      reportDescription: "",
      reportNr: ""
    };
  }

  search = () => {
    const state = this.state;

    const parameter = {
      ...state,
      templateId: state.template ? state.template.value : undefined,
      screwType: state.screwType ? state.screwType.value : undefined,
      dateTo: state.endDate
        ? moment(state.endDate)
            .add(1, "days")
            .format()
        : undefined,
      dateFrom: state.startDate ? moment(state.startDate).format() : undefined,
      screwDiameter: state.screwDiameter.length > 0 ? state.screwDiameter.map(d => d.value).join(" ") : undefined,
      screwLength: state.screwLength.length > 0 ? state.screwLength.map(d => d.value).join(" ") : undefined
    };

    this.props.search(parameter);
  };

  clear = () => {
    this.setState(
      {
        startDate: undefined,
        endDate: undefined,
        customer: "",
        supplier: "",
        screwType: null,
        screwDiameter: [],
        screwLength: [],
        productDescription: "",
        template: null,
        reportDescription: "",
        reportNr: ""
      },
      this.search
    );
  };

  render() {
    const { t } = this.props;
    return (
      <div>
        <div className="element-box">
          <h6 className="element-header">{t("general.search_criteria")}</h6>

          <Row>
            <div className="form-group">
              <label>{t("report.report_no")}</label>
              <input
                value={this.state.reportNr}
                onChange={e => this.setState({ reportNr: e.target.value })}
                name="report_nr"
                placeholder={t("report.report_no")}
                className="form-control"
                type="text"
              />
            </div>

            <div className="form-group">
              <label>{t("report.description")}</label>
              <input
                value={this.state.reportDescription}
                onChange={e => this.setState({ reportDescription: e.target.value })}
                name="reportDescription"
                placeholder="Report Description"
                className="form-control"
                type="text"
              />
            </div>
          </Row>

          <Row>
            <div className="form-group">
              <label>{t("general.date")}</label>
              <br />
              <div style={{ display: "flex" }}>
                <DatePicker
                  dateFormat="dd.MM.yyyy"
                  selected={this.state.startDate}
                  selectsStart
                  startDate={this.state.startDate}
                  endDate={this.state.endDate}
                  onChange={e => this.setState({ startDate: e })}
                  className={"form-control"}
                  placeholderText={t("general.from")}
                  minDate={this.props.searchCriteria.from}
                  maxDate={this.props.searchCriteria.to}
                />
                <div style={{ width: "20px" }} />
                <DatePicker
                  dateFormat="dd.MM.yyyy"
                  selected={this.state.endDate}
                  selectsEnd
                  startDate={this.state.startDate}
                  endDate={this.state.endDate}
                  onChange={e => this.setState({ endDate: e })}
                  className={"form-control"}
                  placeholderText={t("general.to")}
                  minDate={this.props.searchCriteria.from}
                  maxDate={this.props.searchCriteria.to}
                />
              </div>
            </div>
            <div className="form-group">
              <label>{t("report.customer_name")}</label>
              <input
                value={this.state.customer}
                onChange={e => this.setState({ customer: e.target.value })}
                name="customer"
                placeholder={t("report.customer")}
                className="form-control"
                type="text"
              />
            </div>
          </Row>

          <Row>
            <div className="form-group">
              <label>{t("report.supplier_name")}</label>
              <input
                value={this.state.supplier}
                onChange={e => this.setState({ supplier: e.target.value })}
                name="supplier"
                placeholder={t("report.supplier")}
                className="form-control"
                type="text"
              />
            </div>
            <div className="form-group">
              <label>{t("report.screw_type")}</label>
              <Select
                styles={customStyles}
                value={this.state.screwType}
                onChange={st => this.setState({ screwType: st })}
                options={this.props.screwTypes}
                isClearable={true}
                placeholder={t("general.select")}
              />
            </div>
          </Row>

          <Row>
            <div className="form-group">
              <label>{t("report.screw_diameter")}</label>
              <Select
                styles={customStyles}
                value={this.state.screwDiameter}
                onChange={sd => this.setState({ screwDiameter: sd })}
                options={this.props.searchCriteria.diameterValues}
                placeholder={t("general.select")}
                isClearable={true}
                isSearchable={true}
                isMulti
              />
            </div>
            <div className="form-group">
              <label>{t("report.screw_length")}</label>
              <Select
                styles={customStyles}
                value={this.state.screwLength}
                onChange={sl => this.setState({ screwLength: sl })}
                options={this.props.searchCriteria.lengthValues}
                placeholder={t("general.select")}
                isClearable={true}
                isSearchable={true}
                isMulti
              />
            </div>
          </Row>

          <Row>
            <div className="form-group">
              <label>{t("products.description")}</label>
              <input
                value={this.state.productDescription}
                onChange={e => this.setState({ productDescription: e.target.value })}
                name="productDescription"
                placeholder={t("products.description")}
                className="form-control"
                type="text"
              />
            </div>
            <div className="form-group">
              <label>{t("general.test_template")}</label>
              <Select
                styles={customStyles}
                value={this.state.template}
                onChange={template => this.setState({ template })}
                options={this.props.templates}
                placeholder={t("general.select")}
              />
            </div>
          </Row>

          <div className={"row"}>
            <div className="col-sm-12 button-box" starting-position="flex-end">
              <button type="button" className="button" rsize="medium" onClick={this.clear}>
                {t("general.clear")}
              </button>
              <button type="button" className="button" rsize="medium" color="primary" onClick={this.search}>
                {t("general.search")}
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default ReportsSearchReact;
